//import useAuthContext from 'context/auth';
import { useAuthContext } from "../../../context/auth";
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { fromTokenToUsuario } from '../../../services/auth.service';
import { getFamiliar } from '../../../services/serviceFamiliar';
import { getCurrentJwt } from '../../../utils/helpers/jwt.helpers';
import NavMenu from '../NavMenu/NavMenu';
import { useThemeContext } from '../../../context/theme';

const Layout = ({ children, titulo = "Reserva de Centros Recreativos", deQuien = "S", actionNav, menuAuxiliar, tituloMenuAuxiliar, iconoMenuAuxiliar }) => {

    const navigate = useNavigate();
    const { afiliado, setAfiliado } = useAuthContext();
    const { theme, toggleTheme, componentMounted } = useThemeContext();
    const hasSearchedRef = useRef(false);

    useEffect(() => {
        // Evitar múltiples ejecuciones
        if (hasSearchedRef.current) {
            return;
        }

        // Si ya hay un afiliado con datos válidos, no buscar
        if (afiliado && Object.keys(afiliado).length > 0 && afiliado.dni) {
            hasSearchedRef.current = true;
            return;
        }

        const buscarAfiliado = async () => {
            try {
                hasSearchedRef.current = true;
            
                const token = getCurrentJwt();

                if(!token) {
                    // Solo redirigir si estamos en una ruta protegida
                    // No redirigir desde Layout, dejar que ProtectedRoute lo maneje
                    return;
                }

                const afi = await fromTokenToUsuario(token);

                if(!Object.keys(afi).length) {
                    throw new Error("Hubo un problema al intentar obtener los datos del usuario");
                }

                afi.nombreCompleto = afi.apellido + ", " + afi.nombre;

                setAfiliado(afi);
                
                // Solo obtener familiares si no están ya cargados
                if (!afi.grupoFamiliar) {
                    getFamiliar(afi.dni).then((familiares) => {
                        setAfiliado(stateAnterior => ({
                            ...stateAnterior,
                            "grupoFamiliar": familiares
                        }));
                    });
                }
            } catch (err) {
                console.log("No se encontró el afiliado", err);
                hasSearchedRef.current = false; // Permitir reintentar en caso de error
            }
        }
        
        buscarAfiliado();
    }, []) // eslint-disable-line

    // console.log("pathname", router.pathname)
    // useEffect(() => {
    //     console.log("useEffect afiliado", afiliado)
    // }, [afiliado]) // eslint-disable-line

    if (!componentMounted && theme) {
        return <div />
    };

    return (
            <>

                <NavMenu
                    toggleTheme={toggleTheme}
                    theme={theme}
                    titulo={titulo}
                    deQuien={deQuien}
                    actionNav={actionNav}
                    menuAuxiliar={menuAuxiliar}
                    tituloMenuAuxiliar={tituloMenuAuxiliar}
                    iconoMenuAuxiliar={iconoMenuAuxiliar}
                />

                <Container>
                    {/* {
                        (!Object.keys(afiliado).length)
                        ?
                            <h2>Cargando...</h2>
                        : */}
                            {children}
                    {/* } */}
                </Container>
                
            </>
    );
}

export default Layout